import { Col, Row } from "antd";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import CustomerAvatar from "../CustomerAvatar/CustomerAvatar";
import CustomerSidebar from "../CustomerSidebar/CustomerSidebar";
import Layout from "../Layout/Layout";
import styles from "./CustomerLayout.module.scss";

const CustomerLayout = ({ children, breadcrumb }) => {
    return (
        <Layout>
            <div className={styles.customer_layout}>
                <div className="container">
                    <Row>
                        <Col lg={24} xs={0}>
                            <BreadCrumb list={breadcrumb} />
                        </Col>
                    </Row>
                    <Row gutter={[20, 0]}>
                        <Col lg={24}>
                            <CustomerAvatar />
                        </Col>
                        <Col lg={5} xs={24}>
                            <CustomerSidebar />
                        </Col>
                        <Col lg={19} xs={24}>
                            <div className={styles.customer_layout_children}>
                                {children}
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </Layout>
    );
};

export default CustomerLayout;
